import { ArmyCategory } from '@Models';
import { ArmyCategoryState, buildArmyCategoryState } from '@Stores/index';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: ArmyCategoryState = buildArmyCategoryState({
  entity: null,
}) satisfies ArmyCategoryState as ArmyCategoryState;

const armyCategorySlice = createSlice({
  name: 'army-category',
  initialState,
  reducers: {
    setError(state: ArmyCategoryState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
      state.hasError = true;
    },
    setLoading(state: ArmyCategoryState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setArmyCategory(
      state: ArmyCategoryState,
      action: PayloadAction<ArmyCategory>,
    ) {
      state.entity = action.payload;
      state.isLoading = false;
      state.hasError = false;
      state.errorMessage = null;
    },
  },
});

export default armyCategorySlice;
